import details from './details';
import dialoglink from './dialoglink';

nn.registerModule('dialogsummary.Details', (element, options) => {
  details(element, options);
});

nn.registerModule('dialogsummary.DialogLink', (element) => {
  dialoglink(element);
});